import { ColumnDef } from "@tanstack/react-table";
import { FeaturedAdsStatusEnum } from "props/enum";
import { CircularProgress } from "@mui/material";
import { FeaturedAdsProps } from "modules/featured_ads/state/actionType";
import { SpecialOfferProps } from "modules/special_offer/state/actionType";
import ActionButton from "../ActionButton";

export const TableColumns: ColumnDef<SpecialOfferProps>[] = [
  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
    accessorFn: (row) => row?.title,
    id: "title",
    cell: (info) => info.getValue(),
    header: () => <span>Title</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.description,
    id: "description",
    cell: (info) => info.getValue(),
    header: () => <span>Description</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.membership_duration?.package?.name,
    id: "package",
    cell: (info) => info.getValue(),
    header: () => <span>Package</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.membership_duration?.duration_type,
    id: "membership_duration",
    cell: (info) => info.getValue(),
    header: () => <span>Membership Duration</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.start_date,
    id: "start_date",
    cell: (info) => info.getValue(),
    header: () => <span>Start Date</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.end_date,
    id: "end_date",
    cell: (info) => info.getValue(),
    header: () => <span>End Date</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.number_of_days,
    id: "number_of_days",
    cell: (info) => info.getValue(),
    header: () => <span>Number of Days</span>,
    filterFn: "equalsString",
  },
  // {
  //   accessorFn: (row) => row?.upload_status,
  //   id: "upload_status",
  //   cell: (info) => {
  //     const upload_status = info.getValue();
  //     const playback_info = info.row.original.playback_info;
  //     const featured_type = info.row.original.featured_type;
  //     if (featured_type === "image") return null;

  //     const isUploading = !playback_info || playback_info === "";

  //     return (
  //       <span className="flex items-center gap-2">
  //         {isUploading ? (
  //          <> <CircularProgress size={20} thickness={5} className="text-white" /> Uploading...</>
  //         ) : (
  //           <>{String(upload_status)}</>
  //         )}
  //       </span>
  //     );
  //   },
  //   header: () => <span>Video Upload Status</span>,
  //   filterFn: "equalsString",
  // },

  // {
  //   accessorFn: (row) => row?.status,
  //   id: "status",
  //   cell: (info) => {
  //     const status = info.getValue();
  //     return (
  //       <span
  //         className={
  //           status === FeaturedAdsStatusEnum.Published
  //             ? "text-primary-500"
  //             : "text-red-500"
  //         }
  //       >
  //         {String(status)}
  //       </span>
  //     );
  //   },
  //   header: () => <span>Status</span>,
  //   filterFn: "equalsString",
  // },
  {
    accessorFn: (row) => row?.status,
    id: "status",
    cell: (info) => info.getValue(),
    header: () => <span>Status</span>,
    filterFn: "equalsString",
  },
  {
    id: "action",
    cell: ({ row }) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <ActionButton items={row.original} />
        </div>
      );
    },
    header: () => <span>Actions</span>,
    enableSorting: false,
  },
];
